import { render, staticRenderFns } from "./iframe-page-preview.vue?vue&type=template&id=f2223112"
import script from "./iframe-page-preview.vue?vue&type=script&lang=js"
export * from "./iframe-page-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports